import { desserts, mockupUrl, people } from "./images";
import type { FacebookComment } from "../types/facebook";

export const facebookPost = {
  page: "Pack Dulce Saludable",
  avatar: mockupUrl,
  time: "3 d",
  text: "¿Un brownie SIN azúcar refinada, SIN gluten y SIN lactosa que sabe a pastelería? Así lo hacemos en 15 minutos con ingredientes del súper de la esquina. Cuéntanos abajo cuál fue el primer postre que hiciste con el pack.",
  video: desserts.chocolateCake,
  duration: "2:47",
  views: "48 mil reproducciones",
  reactions: 2418,
  comments: 386,
  shares: 912,
};

export const facebookComments: FacebookComment[] = [
  {
    id: "c1",
    author: "Lucía Moyano",
    avatar: people.lucia,
    meta: "Nutricionista · Bogotá, Colombia · Celíaca desde hace 8 años",
    text: "Pensé que nunca volvería a comer un brownie \"de verdad\" desde que descubrí que soy celíaca. Con este pack, mi familia ni siquiera nota la diferencia. Mi mamá comió un muffin y preguntó dónde lo había comprado. Le dije que lo había hecho yo y casi se desmaya. Lo mejor: mi digestión cambió por completo en la primera semana.",
    photo: desserts.lemonMuffins,
    likes: 214,
    reactions: ["love", "like"],
    time: "2 d",
    replies: [
      {
        id: "c1r1",
        author: "Valentina Ríos",
        avatar: people.valentina,
        text: "¿El de limón y amapola está en el pack? Se ve increíble.",
        likes: 18,
        reactions: ["like"],
        time: "2 d",
      },
      {
        id: "c1r2",
        author: "Pack Dulce Saludable",
        avatar: mockupUrl,
        isPage: true,
        text: "¡Sí, Valentina! Está en el Recetario de Muffins junto con 14 recetas más. Y se hace en 20 minutos.",
        likes: 26,
        reactions: ["love"],
        time: "2 d",
      },
    ],
  },
  {
    id: "c2",
    author: "Marta Rosales",
    avatar: people.marta,
    meta: "Madre de dos hijos · Emprendedora · Madrid, España",
    text: "Lo que más me gusta es la Guía de Despensa. Antes gastaba el triple buscando cosas raras en tiendas especiales. Ahora hago muffins para mis hijos con lo que compro en el súper de la esquina. Mis amigas piensan que son comprados en una pastelería. Es la mejor inversión que he hecho este año en mi salud. Además, ahorro como $50-70 mensuales en compras innecesarias.",
    photo: desserts.roseCupcakes,
    likes: 167,
    reactions: ["like", "love"],
    time: "2 d",
    replies: [
      {
        id: "c2r1",
        author: "Rosa Huamán",
        avatar: people.rosa,
        text: "Doy fe de lo de la despensa. Yo estoy en Lima y encontré todo en el supermercado de siempre.",
        likes: 31,
        reactions: ["like"],
        time: "1 d",
      },
    ],
  },
  {
    id: "c3",
    author: "Elena Salguero",
    avatar: people.elena,
    meta: "Coach de bienestar · Miami, USA · Intolerante a la lactosa",
    text: "Soy súper escéptica con los productos \"fit\" porque generalmente saben horrible. Pero las cookies y cremas de este pack son otro nivel. Mi ansiedad por el dulce desapareció porque ahora como cosas que REALMENTE me satisfacen. No es restricción, es libertad. Recomendé a 10 amigas y todas volvieron para comprar.",
    photo: desserts.homemadeOreos,
    likes: 298,
    reactions: ["love", "like", "haha"],
    time: "1 d",
    replies: [
      {
        id: "c3r1",
        author: "Camila Fuentes",
        avatar: people.camila,
        text: "Yo también soy intolerante a la lactosa. ¿Las cremas no llevan nada de leche?",
        likes: 9,
        reactions: ["like"],
        time: "1 d",
      },
      {
        id: "c3r2",
        author: "Elena Salguero",
        avatar: people.elena,
        text: "Nada de nada, Camila. Usan leche de coco y anacardos. La crema de cacao es mi favorita, la pongo hasta en el desayuno.",
        likes: 22,
        reactions: ["love"],
        time: "1 d",
      },
    ],
  },
  {
    id: "c4",
    author: "Patricia Valverde",
    avatar: people.patricia,
    meta: "Madre · Gestora de salud infantil · Guadalajara, México",
    text: "Mi hijo tiene TDAH y después de usar las recetas para niños del pack, notamos una diferencia NOTABLE en su comportamiento. Come postres saludables sin saber que son saludables y sin los picos de azúcar que lo dejaban imposible. Ahora mis amigas me piden las recetas porque sus hijos también quieren \"las galletas de mi mamá\".",
    photo: desserts.starCookies,
    likes: 341,
    reactions: ["love", "like"],
    time: "20 h",
    replies: [
      {
        id: "c4r1",
        author: "Pack Dulce Saludable",
        avatar: mockupUrl,
        isPage: true,
        text: "Patricia, gracias por compartirlo. Leer historias como la tuya es la razón por la que hacemos esto.",
        likes: 47,
        reactions: ["love"],
        time: "18 h",
      },
    ],
  },
];

export const extraComments: FacebookComment[] = [
  {
    id: "c5",
    author: "Daniela Ortiz",
    text: "Hice las paletas de cacao y menta el fin de semana y mis sobrinos pidieron otra ronda. Nadie creyó que no tenían azúcar.",
    photo: desserts.popsicles,
    likes: 88,
    reactions: ["like", "love"],
    time: "15 h",
  },
  {
    id: "c6",
    author: "Gabriela Méndez",
    text: "Compré ayer, hoy ya hice el cheesecake sin hornear. 10 de 10.",
    likes: 54,
    reactions: ["like"],
    time: "6 h",
  },
];
